import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StorageServiceModule } from 'angular-webstorage-service';
import { GlobalVariablesProviderService } from './services/global-variables-provider.service';
import { PermissionsProviderService } from './services/permissions-provider.service';
import { AuthHttpInterceptorService } from './services/auth-http-interceptor.service';
import { ContentsService } from './data-services/contents.service';
import { UsersService } from './data-services/users.service';
import { FormsService } from './data-services/forms.service';
import { TemplatesService } from './data-services/templates.service';
import { SystemService } from './data-services/system.service';
import { AuthTokenService } from './services/auth-token.service';
import { AuthShowDirective } from './directives/auth-show.directive';
import { AuthEnableDirective } from './directives/auth-enable.directive';
import { NameFilterPipe } from './filters/name-filter.pipe';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

@NgModule({
  imports: [
    CommonModule,
    StorageServiceModule
  ],
  providers: [],
  declarations: [
    AuthShowDirective,
    AuthEnableDirective,
    NameFilterPipe
  ],
  exports: [
    NameFilterPipe
    /*GlobalVariablesProviderService,
    AuthHttpInterceptorService,
    ContentsService,
    UsersService,
    FormsService,
    TemplatesService,
    SystemService,
    PermissionsProviderService,
    AuthTokenService*/
  ]
})
export class DconfigCoreModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: DconfigCoreModule,
      providers: [
        { provide: HTTP_INTERCEPTORS, useClass: AuthHttpInterceptorService, multi: true }, GlobalVariablesProviderService, AuthTokenService, PermissionsProviderService
        //ContentsService, UsersService, FormsService, TemplatesService, SystemService, 
      ]
    };
  }
}
